import { useEffect } from 'react';
import { DatePicker } from 'screens/Admin/components';

const DateTime = ({ date, setDate, data }) => {
  useEffect(() => {
    setDate(new Date(data.date));
  }, []);

  function handleSelect(val) {
    setDate(val);
  }

  return (
    <DatePicker
      marg="24px 0 0"
      title="Date"
      selected={date}
      handleSelect={handleSelect}
      timeIntervals={5}
    />
  );
};

export default DateTime;
